module.exports = __webpack_public_path__ + "assets/img/login-bg.f220b2b8.png";